<!-- Container-fluid starts-->
<div class="container">
    <div class="row">
        <div class="col-sm-12 info-block">
            <div class="nom-id">
                {{this.admin.lastName}}
            </div>
            <div class="info">
                <div class="d-flex flex-row">
                    <div class="d-flex flex-column flex-33">
                        <p class="title">{{this.admin.lastName}} {{this.admin.firstName}}</p>
                        <!-- Address -->
                        <div class="info-detail-block d-flex flex-row">
                            <i class="fa fa-home" aria-hidden="true"></i>
                            <div>
                                <p>{{this.admin.userStreet}}</p>
                                <p>{{this.admin.userPostalCode}} {{this.admin.userState}} {{this.admin.userCity}}
                                    <span *ngIf="this.admin.userCountry">, </span>{{this.admin.userCountry}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <!-- Contact -->
                    <div class="d-flex flex-column flex-33">
                        <p class="title">Contact</p>
                        <div class="info-detail-block d-flex flex-row" *ngIf="this.admin.email">
                            <i class="fa fa-envelope-o" aria-hidden="true"></i>
                            <div>
                                <p>{{this.admin.email}}</p>
                            </div>
                        </div>
                        <div class="info-detail-block d-flex flex-row" *ngIf="this.admin.phone">
                            <i class="fa fa-phone" aria-hidden="true"></i>
                            <div>
                                <p>{{this.admin.phone}}</p>
                            </div>
                        </div>
                    </div>
                    <!-- Organization -->
                    <div class="d-flex flex-column flex-33">
                        <p class="title">Société</p>
                        <div>
                            <p>{{this.admin.nameOrganization}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 d-flex flex-column modify-block">
            <button class="modify modify-info btn_modify_info" (click)="openAccountModification()">
                Modifier mes informations
                <span>
                    <i class="fa fa-edit fa-lg" aria-hidden="true"></i>
                </span>
            </button>
            <button class="modify modify-pass btn_modify_pwd" (click)="openAccountModificationPassword()">
                Modifier mon mot de passe
                <span>
                    <i class="fa fa-lock fa-lg" aria-hidden="true"></i>
                </span>
            </button>
        </div>
    </div>
</div>
  <!-- Container-fluid Ends-->